<script setup>
const props = defineProps({
    idsolicitacao: {
        type: [String, Number],
        default: null
    },
    tipoSolicitacao: {
        type: String,
    },
    tipoCadastro: {
        type: String,
    },
    tutorial: {
        type: Boolean,
    },
    descricao: {
        type: String,
    }
});

const emit = defineEmits(['iniciarTour']);

const handleIniciarTour = () => {
    emit('iniciarTour');
};

</script>
<template>
    <ReturnTrail action="historicoAnterior" :icon="true" />

    <div class="w-full flex justify-content-between flex-column gap-5 lg:flex-row">
        <div class="flex flex-column gap-2 align-items-baseline">
            <div class="flex align-items-center gap-3">
                <h1 class="text-900 m-0 text-3xl md:text-4xl" v-if="props.tipoSolicitacao">
                    {{ props.idsolicitacao ? 'Editar Solicitação de ' + props.tipoSolicitacao : 'Nova Solicitação de ' + props.tipoSolicitacao }}
                </h1>
                <h1 class="text-900 m-0 text-3xl md:text-4xl" v-if="props.tipoCadastro">
                    {{ props.idsolicitacao ? 'Editar' + props.tipoCadastro : '' + props.tipoCadastro }}
                </h1>
            </div>

            <div class="flex flex-row gap-2 flex-wrap lg:gap-4">
                <p class="text-600 font-normal m-0 text-sm" v-if="props.tipoSolicitacao">
                    {{ props.idsolicitacao ? 'Edite os dados para atualizar a solicitação.' : 'Preencha os dados para cadastrar uma nova solicitação.' }}
                </p>
                <p class="text-600 font-normal m-0 text-sm" v-if="props.tipoCadastro && !props.descricao">
                    {{ props.idsolicitacao ? 'Edite os dados para atualizar o cadastro.' : 'Preencha os dados para realizar o cadastro.' }}
                </p>
                <p class="text-600 font-normal m-0 text-sm" v-if="props.tipoCadastro && props.descricao">
                    {{ props.descricao }}
                </p>
            </div>

            <Button v-if="!props.idsolicitacao && props.tutorial" @click="handleIniciarTour" icon="pi pi-compass"
                label="Fazer tutorial" class="mt-3" size="small" severity="secondary" outlined rounded />
        </div>
    </div>
</template>
